import { render, staticRenderFns } from "./ProfileEditor.vue?vue&type=template&id=a08ac8c0&"
import script from "./ProfileEditor.vue?vue&type=script&lang=js&"
export * from "./ProfileEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports